var U = 100;
function X(O) {
  var n = O.fontFamily, e = O.fontSize, W = !!(n || e);
  n === void 0 && (n = "Calibri"), e === void 0 && (e = 12);
  var u = [], D = {}, g = [], j = {}, i = [], S = {}, l = [], v = {}, d = [], h = {};
  i.push({
    size: e,
    family: n,
    custom: W
  }), S["-:-"] = 0, l.push({}), v["-"] = 0, d.push({
    left: {},
    right: {},
    top: {},
    bottom: {}
  }), h["-:-/-:-/-:-/-:-"] = 0, l.push({
    gray125: !0
  });
  function q(t, Q) {
    var E = t.align, G = t.alignVertical, H = t.textRotation, J = t.indent, L = t.wrap, m = t.fontFamily, b = t.fontSize, p = t.fontWeight, B = t.fontStyle, I = t.color, C = t.backgroundColor, o = t.borderColor, r = t.borderStyle, x = t.leftBorderColor, F = t.leftBorderStyle, z = t.rightBorderColor, R = t.rightBorderStyle, w = t.topBorderColor, k = t.topBorderStyle, K = t.bottomBorderColor, T = t.bottomBorderStyle, a = Q.format, V = "".concat(m || "-", ":").concat(b || "-", ":").concat(p || "-", ":").concat(B || "-", ":").concat(I || "-"), A = C || "-", M = "".concat(w || o || "-", ":").concat(k || r || "-") + "/" + "".concat(z || o || "-", ":").concat(R || r || "-") + "/" + "".concat(K || o || "-", ":").concat(T || r || "-") + "/" + "".concat(x || o || "-", ":").concat(F || r || "-"), N = "".concat(E || "-", "/").concat(G || "-", "/").concat(H || "-", "/").concat(J || "-", "/").concat(L || "-", "/").concat(a || "-", "/").concat(V, "/").concat(A, "/").concat(M), P = j[N];
    if (P !== void 0)
      return P;
    var c;
    a && (c = D[a], c === void 0 && (c = D[a] = String(U + u.length), u.push(a)));
    var s = W ? 0 : void 0;
    (m || b || p || B || I) && (s = S[V], s === void 0 && (s = S[V] = String(i.length), i.push({
      custom: !0,
      size: b || e,
      family: m || n,
      weight: p,
      style: B,
      color: I
    })));
    var f;
    C && (f = v[A], f === void 0 && (f = v[A] = String(l.length), l.push({
      color: C
    })));
    var y;
    return (o || r || x || F || z || R || w || k || K || T) && (y = h[M], y === void 0 && (y = h[M] = String(d.length), d.push({
      left: {
        style: F || r,
        color: x || o
      },
      right: {
        style: R || r,
        color: z || o
      },
      top: {
        style: k || r,
        color: w || o
      },
      bottom: {
        style: T || r,
        color: K || o
      }
    }))), g.push({
      fontId: s,
      fillId: f,
      borderId: y,
      align: E,
      alignVertical: G,
      textRotation: H,
      indent: J,
      wrap: L,
      formatId: c
    }), j[N] = String(g.length - 1);
  }
  return q({}, {}), {
    getStyles: function() {
      return {
        formats: u,
        styles: g,
        fonts: i,
        fills: l,
        borders: d
      };
    },
    getStyle: q
  };
}
export {
  U as FORMAT_ID_STARTS_FROM,
  X as default
};
//# sourceMappingURL=index.es244.js.map
